<static-hdr></static-hdr>

<section class="billboard">
  <div class="container h-100 d-flex align-items-center">

    <div>
      <h1 class="mb-10 mb-lg-20">برنامج كفاءة الطاقة للجهات الحكومية</h1>
      
      <div>
        <button [routerLink]="['/about']" class="btn btn-warning font-size-h1-lg px-8">اعرف اكثر</button>
        <!-- <button class="btn btn-warning font-size-h1-lg px-5"> <i class="fa fa-play"></i> </button> -->
      </div>
    </div>
  </div>
  
</section>


<section class="my-20">
  <div class="container">

    <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 justify-content-center">
      <div class="col text-center my-10 my-lg-0">
        <img src="/assets/common/images/lightbulb-on.png" alt="lightbulb-on" />
        <h2 class="my-5">الهدف</h2>
        <h4 class="text-black-50 line-height-lg px-md-15">يهدف البرنامج الي تقليل حجم استخدام الطاقة في الجهات الحكوميه بمختلف المباني</h4>
      </div>
      <div class="col text-center my-10 my-lg-0">
        <img src="/assets/common/images/desktop-alt.png" alt="desktop-alt" />
        <h2 class="my-5">التوعية</h2>
        <h4 class="text-black-50 line-height-lg px-md-15">يقدم البرنامج العديد من البرامج التوعويه والخطط التفاعليه وذلك لدعم الجهات في تقليل الاستهلاك</h4>
      </div>
      <div class="col text-center my-10 my-lg-0">
        <img src="/assets/common/images/phone-volume.png" alt="phone-volume" />
        <h2 class="my-5">الدعم</h2>
        <h4 class="text-black-50 line-height-lg px-md-15">نوفر العديد من قنوات الاتصال لنمكن الجميع من التواصل معنا بشكل ميسر وسهل</h4>
      </div>
      
    </div>
    
  </div>

</section>


<static-ftr></static-ftr>